import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const paymentNoticesModule = {
  namespaced: true,
  state: {
    paymentNoticesData: [],
    paymentNotice: []
  },
  getters: {
    getPaymentNoticesData: (state) => state.paymentNoticesData,
    getPaymentNotice: (state) => state.paymentNotice
  },
  mutations: {
    SET_PAYMENT_NOTICES_DATA(state, payload) {
      state.paymentNoticesData = payload
    },
    SET_PAYMENT_NOTICE(state, payload) {
      state.paymentNotice = payload
    }
  },
  actions: {
    async GET_PAYMENT_NOTICES_DATA({ commit }, payload) {
      const { communityId } = payload
      try {
        const res = await baseFetch(
          API.getPaymentNoticeList.url(communityId),
          API.getPaymentNoticeList.method
        )

        if (!res.isError && res.data) {
          commit('SET_PAYMENT_NOTICES_DATA', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async GET_PAYMENT_NOTICE({ commit }, payload) {
      const { paymentNoticeId } = payload
      try {
        const res = await baseFetch(
          API.getPaymentNotice.url(paymentNoticeId),
          API.getPaymentNotice.method
        )

        if (!res.isError && res.data) {
          commit('SET_PAYMENT_NOTICE', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async SEND_PAYMENT_NOTICE({ commit }, payload) {
      try {
        const res = await baseFetch(
          API.sendPaymentNotice.url,
          API.sendPaymentNotice.method,
          payload
        )

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  }
}

export default paymentNoticesModule
